import { render, staticRenderFns } from "./DragIcon.vue?vue&type=template&id=3070b15c&"
import script from "./DragIcon.vue?vue&type=script&lang=js&"
export * from "./DragIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports